<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="900">
      <v-card v-if="showPallet">
        <v-card-text>
          <h2>
            {{ $t("pallet.pallet") }}
            {{ pallet.getNumber() }}:
            <span class="pallet_dimensions"
              >{{ pallet.length }}x{{ pallet.width }}, H={{
                calculateHeight(pallet)
              }}, {{ calculateWeight(pallet) }}kg</span
            >
          </h2>
          <div class="container">
            <div class="row">
              <div id="pallet-top" class="col">
                <pallet-top
                  :pallet="pallet"
                  :divider="dividerTop"
                  :settings="settings"
                  :showTexts="true"
                />
              </div>
            </div>
            <div class="row">
              <div id="pallet-side" class="col">
                <pallet-side
                  :pallet="pallet"
                  :divider="dividerSide"
                  :settings="settings"
                />
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">{{
            $t("pallet_quick_view_dialog.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Pallet from "@/models/Pallet.js";
import Helper from "@/models/Helper.js";
import PalletTop from "@/components/user/pallets/PalletTop.vue";
import PalletSide from "@/components/user/pallets/PalletSide.vue";
export default {
  components: {
    PalletTop,
    PalletSide
  },
  data() {
    return {
      dialog: false,
      showPallet: false,
      palletId: null,
      pallet: {},
      settings: {
        palletHeight: 120,
        palletWeight: 2000,
        spacingBetween: 0,
        spacingEnds: 0,
        spacingSides: 0
      },
      dividerTop: 6,
      dividerSide: 9
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.showPallet = false;
      }
    },
    palletId(val) {
      this.getPallet(val);
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.handleResize();
    });
  },
  methods: {
    async getPallet(palletId) {
      this.dividerTop = 6;
      this.dividerSide = 9;
      const pallet = await Pallet.loadPallet(palletId, {
        with_products: 1,
        with_order: 1
      });
      this.pallet = pallet;
      this.dialog = true;
      this.showPallet = true;
      await Helper.timeout(50);
      this.handleResize();
    },

    handleResize() {
      if (
        this.pallet != null &&
        document.getElementById("pallet-top") != null
      ) {
        if (this.pallet.length == 0 || this.pallet.width == 0) {
          return 0;
        }
        const dividerTop =
          this.pallet.length /
          (document.getElementById("pallet-top").offsetWidth - 50);
        const dividerSide = this.pallet.getHeight() / 200;
        this.dividerTop = dividerTop <= 3 ? 3 : dividerTop;
        this.dividerSide = dividerSide <= 10 ? 10 : dividerSide;
      }
    },
    palletNumber(number) {
      if (number != "") {
        return number;
      }
      return "1";
    },
    /**
     * gets sum of products on pallet weights
     * @param pallet
     */
    calculateWeight(pallet) {
      return pallet.getWeight();
    },
    /**
     * gets heighest elevated product height in m
     * @param pallet
     */
    calculateHeight(pallet) {
      return pallet.getHeight();
    }
  }
};
</script>

<style scoped>
span {
  font-size: 14px;
}
</style>
